/** Contrat auth commun renvoyé par /v2/auth/{login,register,refresh,ximi}. */
export interface AuthTokens {
    accessToken: string;
    refreshToken: string;
}

/** Machine-readable error codes of the /v2/auth/* routes (mirror of the API catalog). */
export const AuthApiErrorCode = {
    USE_SSO: 'USE_SSO',
    PASSWORD_RESET_REQUIRED: 'PASSWORD_RESET_REQUIRED',
    ACCOUNT_LOCKED: 'ACCOUNT_LOCKED',
    ACCOUNT_DISABLED: 'ACCOUNT_DISABLED',
    EMAIL_TAKEN: 'EMAIL_TAKEN',
    INVALID_CODE: 'INVALID_CODE',
    CODE_ATTEMPTS_EXCEEDED: 'CODE_ATTEMPTS_EXCEEDED'
} as const;
